"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PromoBanner = void 0;
var _mui = require("@ori-ui/mui");
var _imageSizesHelper = require("@ori/image-sizes-helper");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _head = _interopRequireDefault(require("next/head"));
var _react = require("react");
var _models = require("../../models");
var _constants = require("../BannerProductListing/constants");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Promo banner component, used in product listing page
 */ const PromoBanner = (param)=>{
    let { backgroundImage, backgroundVideo, link, fontColor, verticalAlignment, title, size, className } = param;
    const { relativeUrl, title: linkTitle } = link !== null && link !== void 0 ? link : {};
    const theme = (0, _mui.useTheme)();
    const { getTestId } = (0, _testidGenerator.default)();
    const imagesVariants = (0, _react.useMemo)(()=>backgroundImage ? {
            url: backgroundImage,
            backgroundColor: theme.palette.grey[100],
            imageFormat: 'WebP',
            imageSizeMultiplier: 2,
            params: [
                {
                    width: _constants.BANNER_SIZE_IN_PX.Size1,
                    quality: 90
                },
                {
                    width: _constants.BANNER_SIZE_IN_PX.Size2,
                    quality: 90
                },
                {
                    width: 200,
                    quality: 90
                },
                {
                    width: 300,
                    quality: 90
                },
                {
                    width: 400,
                    quality: 90
                },
                {
                    width: 600,
                    quality: 90
                }
            ]
        } : undefined, [
        backgroundImage,
        theme.palette.grey
    ]);
    var _backgroundVideo_playInLoop;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Banner, {
        className: className,
        hasLink: !!relativeUrl,
        size: size,
        "data-testid": getTestId(_constants2.PROMO_BANNER),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_mui.Link, {
            href: relativeUrl !== null && relativeUrl !== void 0 ? relativeUrl : undefined,
            children: [
                (backgroundVideo === null || backgroundVideo === void 0 ? void 0 : backgroundVideo.id) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.BannerVideo, {
                    autoPlay: true,
                    playsInline: true,
                    muted: true,
                    "data-testid": getTestId(_constants2.PROMO_BANNER_VIDEO),
                    src: backgroundVideo.id,
                    loop: (_backgroundVideo_playInLoop = backgroundVideo.playInLoop) !== null && _backgroundVideo_playInLoop !== void 0 ? _backgroundVideo_playInLoop : true
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.BannerImage, {
                            alt: linkTitle !== null && linkTitle !== void 0 ? linkTitle : '',
                            "data-testid": getTestId(_constants2.PROMO_BANNER_IMAGE),
                            fetchPriority: "high",
                            sizes: "(max-width: 450px) ".concat(size === _models.EditorialPlpPromoBannerSize.Size1 ? 200 : 400, "px,\n              (max-width: ").concat(theme.breakpoints.values.sm - 1, "px) ").concat(size === _models.EditorialPlpPromoBannerSize.Size1 ? 300 : 600, "px, ").concat(_constants.BANNER_SIZE_IN_PX[size], "px"),
                            src: backgroundImage,
                            srcSet: imagesVariants ? (0, _imageSizesHelper.generateSrcSet)((0, _imageSizesHelper.getImageVariants)(imagesVariants)) : undefined
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_head.default, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                                rel: "preload",
                                as: "image",
                                href: backgroundImage,
                                imageSrcSet: imagesVariants ? (0, _imageSizesHelper.generateSrcSet)((0, _imageSizesHelper.getImageVariants)(imagesVariants)) : undefined,
                                imageSizes: "(max-width: 450px) ".concat(size === _models.EditorialPlpPromoBannerSize.Size1 ? 200 : 400, "px,\n                (max-width: ").concat(theme.breakpoints.values.sm - 1, "px) ").concat(size === _models.EditorialPlpPromoBannerSize.Size1 ? 300 : 600, "px, ").concat(_constants.BANNER_SIZE_IN_PX[size], "px")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.BannerTextContainer, {
                    "data-testid": getTestId(_constants2.PROMO_BANNER_TITLE),
                    fontColor: fontColor,
                    verticalAlignment: verticalAlignment,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.BannerTitle, {
                            variant: "h6",
                            component: "h6",
                            children: title
                        }),
                        linkTitle ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.BannerTitleLinkImitation, {
                            variant: "caption",
                            fontColor: fontColor,
                            "data-testid": getTestId(_constants2.PROMO_BANNER_FAKE_LINK),
                            children: linkTitle
                        }) : null
                    ]
                })
            ]
        })
    });
};
exports.PromoBanner = PromoBanner;
